export function getFormUrl(formId: string): string {
  const urls: Record<string, string> = {
    "contato-bigmania": "https://form.readdy.ai/api/form/contato-bigmania",
  };
  return urls[formId] || "#";
}